import { Map } from 'immutable';
import {
  FETCH_UNIT_RESOURCES_SUCCESS,
} from './actions';
import { buildUnitResourcesKey, toStudentUnitResourcesList } from './model';

export default function unitResources(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_UNIT_RESOURCES_SUCCESS:
      return state.set(
        buildUnitResourcesKey(action.groupId, action.unitId),
        toStudentUnitResourcesList(action.payload)
      );
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/UnitResources/reducer.js